module.exports = __webpack_public_path__ + "img/mongo-logo.771345a9.svg";